export default __webpack_public_path__ + "static/media/blue.f5fcb354.jpg";